import {ChangeDetectionStrategy, Component} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {RouterModule} from '@angular/router';
import {TranslatePipe} from '@ngx-translate/core';
import {isInBrowser} from "../../../utils/clientutils";
import {MainPagesContainerComponent} from '../main-pages-container/main-pages-container.component';
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['../main.pages.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        MainPagesContainerComponent,
        MatButtonModule,
        RouterModule,
        TranslatePipe
    ]
})
export class HomeComponent {
    protected isClosed = false

    constructor() {
        const host = isInBrowser() ? window.location.hostname : environment.prerenderDomain;
        this.checkSiteAndClose(host);
    }

    checkSiteAndClose(url: string): void {
        this.isClosed = url === 'virt-chat.com'
    }
}
